import { bind, play, setEnabled, setVolume } from 'cuelume';

const KEY = 'teams-sound-enabled';
let initialized = false;

export function soundEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
}

export function initSounds(): void {
  if (initialized) return;
  initialized = true;
  bind();
  setVolume(0.55);
  setEnabled(soundEnabled());
}

export function setSoundEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? '1' : '0');
  } catch {
    /* Sound preference is optional when storage is unavailable. */
  }
  setEnabled(enabled);
}

export { play };
